// extracted by mini-css-extract-plugin
module.exports = {"crmCarouselTheme":"_bfa6aa0"};